import { Injectable } from '@angular/core';
import { environment } from '../../../assets/environment';

@Injectable({
    providedIn: 'root'
})
export class ConfigService {

    static dateFormat = 'DD.MM.YYYY';
    static shortTimeFormat = 'DD.MM.YYYY HH:mm';
    static timestampFormat = 'DD.MM.YYYY HH:mm:ss';
    static timeFormat = 'MMMM D, YYYY h:mm a';
    static timeFormatMatch = 'MMMM D, YYYY h:mm a';

    // ping the resource server every x seconds
    static heartbeatTimeout = 60000;
    // check locally every 5000 milliseconds if connected flag is true
    static onlineCheckTimeout = 5000;
    // role prefixes
    static rolePrefix = 'AC';
    static roleDiv = '_';
    static roleManage = 'MANAGE';
    static roleReadOnly = 'READ';
    // show all roles (true) on user details or only the roles the current user has (false)
    static role_show_always = true;
    static roleDomains = ['Platform', 'Player', 'Project', 'Profile', 'Customer', 'User', 'Notification', 'Label'];

    static getAuthEndpoint() {
        return this.getBaseURL() + 'auth/';
    }

    static getApiEndpoint() {
        return this.getBaseURL() + 'api/';
    }

    static getBaseURL() {
        const host = location.host.split(':')[0];
        return location.protocol + '//' + host + (host === 'localhost' ? ':9001' : '') + '/';
    }
}
